import * as types from './mutation-types'

export const toggleSidebar = ({ commit }, config) => {
  if (config instanceof Object) {
    commit(types.TOGGLE_SIDEBAR, config)
  }
}

export const toggleDevice = ({ commit }, device) => commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({ commit }, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const switchEffect = ({ commit }, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}

/**
 * Makes a message object containing the config object and a promise.
 * The promise should resolve if the user wants to delete and reject if not
 * @param context
 * @param config
 * @returns {Promise<any>}
 */
export const makeDeleteMessage = (context, config) => {
  return new Promise((resolve, reject) => {
    const message = {
      config: config,
      resolve: resolve,
      reject: reject
    }

    context.commit(types.MAKE_DELETE_MESSAGE, message)
  })
}

export const acceptDelete = (context, forceDelete) => {
  context.commit(types.ACCEPT_DELETE, forceDelete)
}

export const rejectDelete = (context) => {
  context.commit(types.REJECT_DELETE)
}
